import { html } from "lit";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { ifDefined } from "lit/directives/if-defined.js";

const exampleTableDataTechnicalData = {
    header: [
        "",
        "TruLaser 1030 fiber",
        "TruLaser 1040 fiber",
        "TruLaser 1060 fiber",
    ],
    categories: [
        {
            name: "Abmessungen",
            rows: [
                [
                    {
                        text: "Länge",
                        footnotes: "",
                    },
                    {
                        text: "9333 mm",
                        footnotes: "",
                    },
                    {
                        text: "11150 mm",
                        footnotes: "",
                    },
                    {
                        text: "15500 mm",
                        footnotes: "",
                    },
                ],
                [
                    {
                        text: "Breite",
                        footnotes: "",
                    },
                    {
                        text: "5990 mm",
                        footnotes: "",
                    },
                    {
                        text: "6650 mm",
                        footnotes: "",
                    },
                    {
                        text: "7150 mm",
                        footnotes: "",
                    },
                ],
                [
                    {
                        text: "Höhe",
                        footnotes: "",
                    },
                    {
                        text: "2200 mm",
                        footnotes: "",
                    },
                    {
                        text: "2200 mm",
                        footnotes: "",
                    },
                    {
                        text: "2200 mm",
                        footnotes: "",
                    },
                ],
            ],
        },
        {
            name: "Gewicht",
            rows: [
                [
                    {
                        text: "Gewicht Grundmaschine",
                        footnotes: "",
                    },
                    {
                        text: "9400 kg",
                        footnotes: "1",
                    },
                    {
                        text: "12000 kg",
                        footnotes: "1",
                    },
                    {
                        text: "16500 kg",
                        footnotes: "1",
                    },
                ],
            ],
        },
        {
            name: "Maximale Geschwindigkeit",
            rows: [
                [
                    {
                        text: "Simultan",
                        footnotes: "",
                    },
                    {
                        text: "140 m/min",
                        footnotes: "",
                    },
                    {
                        text: "140 m/min",
                        footnotes: "",
                    },
                    {
                        text: "140 m/min",
                        footnotes: "",
                    },
                ],
            ],
        },
        {
            name: "Arbeitsbereich",
            rows: [
                [
                    {
                        text: "X-Achse",
                        footnotes: "",
                    },
                    {
                        text: "3000 mm",
                        footnotes: "",
                    },
                    {
                        text: "4000 mm",
                        footnotes: "",
                    },
                    {
                        text: "6000 mm",
                        footnotes: "",
                    },
                ],
                [
                    {
                        text: "Y-Achse",
                        footnotes: "",
                    },
                    {
                        text: "1500 mm",
                        footnotes: "",
                    },
                    {
                        text: "2000 mm",
                        footnotes: "",
                    },
                    {
                        text: "2500 mm",
                        footnotes: "",
                    },
                ],
                [
                    {
                        text: "Max. Werkstückgewicht ohne Schwerlastpalettenwechsler",
                        footnotes: "",
                    },
                    {
                        text: "900 kg",
                        footnotes: "",
                    },
                    {
                        text: "2000 kg",
                        footnotes: "",
                    },
                    {
                        text: "2900 kg",
                        footnotes: "",
                    },
                ],
                [
                    {
                        text: "Max. Werkstückgewicht mit Schwerlastpalettenwechsler",
                        footnotes: "",
                    },
                    {
                        text: "1800 kg",
                        footnotes: "",
                    },
                    {
                        text: "3300 kg",
                        footnotes: "",
                    },
                    {
                        text: "4900 kg",
                        footnotes: "",
                    },
                ],
                [
                    {
                        text: "Max. Werkstückgewicht auf beiden Paletten mit Schwerlastpalettenwechsler",
                        footnotes: "",
                    },
                    {
                        text: "2200 kg",
                        footnotes: "2",
                    },
                    {
                        text: "3900 kg",
                        footnotes: "2",
                    },
                    {
                        text: "5700 kg",
                        footnotes: "2",
                    },
                ],
            ],
        },
    ],
};

const createTechnicalDataTableMarkup = () => {
    const lines: string[] = [];
    lines.push(`<table>`);
    lines.push(`    <thead>`);
    lines.push(`        <tr>`);
    exampleTableDataTechnicalData.header.forEach((cell) => {
        if (cell) {
            lines.push(
                `            <th scope="col"><span class="ux-text-title ux-text-title--bold">${cell}</span></th>`
            );
        } else {
            lines.push(`            <td>&nbsp</td>`);
        }
    });
    lines.push(`        </tr>`);
    lines.push(`    </thead>`);
    lines.push(`    <tbody>`);
    exampleTableDataTechnicalData.categories.forEach(({ name, rows }) => {
        lines.push(`        <tr class="cat">`);
        lines.push(
            `            <th scope="rowgroup" colspan="${exampleTableDataTechnicalData.header.length}">${name}</th>`
        );
        lines.push(`        </tr>`);
        rows.forEach((cells) => {
            lines.push(`        <tr class="sub-cat">`);
            cells.forEach((cell, index) => {
                const footnotes = cell.footnotes
                    ? `\n                <sup><span class="footnotes-reference">${cell.footnotes}</span></sup>`
                    : "";
                if (index === 0) {
                    lines.push(
                        `            <th scope="row">${cell.text}${footnotes}</th>`
                    );
                } else {
                    lines.push(`            <td>${cell.text}${footnotes}</td>`);
                }
            });
            lines.push(`        </tr>`);
        });
    });
    lines.push("    </tbody>");
    lines.push("</table>");
    return lines.join("\n");
};

const exampleTableCookieList = `
<table>
    <thead>
    <tr>
        <th scope="col">Unternehmen</th>
        <th scope="col">Betroffene Drittländer</th>
        <th scope="col">Rechtliche Grundlage</th>
    </tr>
    </thead>
    <tbody>
    <tr>
        <th scope="row">Akamai Technologies, Inc.</th>
        <td>USA</td>
        <td>EU-US Data Privacy Framework Agreement</td>
    </tr>
    <tr>
        <th scope="row">Fonticons , Inc</th>
        <td>USA</td>
        <td>Einwilligung, Art. 49 Abs. 1 lit. a DSGVO</td>
    </tr>
    <tr>
        <th scope="row">Google LLC</th>
        <td>USA</td>
        <td>EU-US Data Privacy Framework Agreement</td>
    </tr>
    <tr>
        <th scope="row">Hotjar UK Limited</th>
        <td>Vereinigtes Königreich</td>
        <td>Angemessenheitsbeschluss</td>
    </tr>
    <tr>
        <th scope="row">LinkedIn Corporation</th>
        <td>USA</td>
        <td>Standardvertragsklausen</td>
    </tr>
    <tr>
        <th scope="row">Meta Platforms, Inc.</th>
        <td>USA</td>
        <td>Einwilligung, Art. 49 Abs. 1 lit. a DSGVO</td>
    </tr>
    <tr>
        <th scope="row">Microsoft Corporation</th>
        <td>USA</td>
        <td>EU-US Data Privacy Framework Agreement</td>
    </tr>
    <tr>
        <th scope="row">X Corp.</th>
        <td>USA</td>
        <td>Einwilligung, Art. 49 Abs. 1 lit. a DSGVO</td>
    </tr>
    </tbody>
</table>
`;

const exampleTableTechnicalData = createTechnicalDataTableMarkup();

export const exampleSlots: Record<string, string> = {
    "Cookie List Table": exampleTableCookieList,
    "Technical Data Table": exampleTableTechnicalData,
};

export const Template = ({
    exampleSlot,
    fullWidth,
    stickyHeader,
    stickyRowHeader,
    variant,
    _slot = "",
}) => {
    const slot = exampleSlots[exampleSlot]
        ? unsafeHTML(exampleSlots[exampleSlot])
        : unsafeHTML(_slot);
    const isStoryMode =
        window.top.location.href.match(/path=\/story/) ||
        window.top.location.href.match(/viewMode=story/);
    return html`
        <ux-iws-comparison-table
            ?full-width=${ifDefined(fullWidth)}
            ?sticky-header=${ifDefined(stickyHeader)}
            ?sticky-row-header=${ifDefined(stickyRowHeader)}
            variant=${ifDefined(variant)}
        >
            ${slot}
        </ux-iws-comparison-table>
        ${isStoryMode && html`<div style="height: 100vh"></div>`}
    `;
};
